var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pageError" }, [
    _vm._v(" " + _vm._s(_vm.errorType) + " "),
    _c("div", { staticClass: "pageNotFound" }, [
      _c("img", { attrs: { src: require("@/assets/images/404.webp") } }),
      _c("h2", [_vm._v(_vm._s(_vm.$t("Oops")))]),
      _c("p", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.$t("We could not find the page."))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }